export class Afiliacion{
    constructor(){
        
    }
}